<div #navbar class="navbar">
  <div class="navbar-logo flex-row">
    <app-navbar-menu-toggle-button></app-navbar-menu-toggle-button>
    <app-default-logo-version [includeVersion]="config.showVersion"></app-default-logo-version>
  </div>
  <div class="spacer d-lg-none"></div>
  <div class="button-group" #optionContainer></div>
</div>
